import { RootState } from 'redux/store';

export const selectIsLoading = (state: RootState) => state.footage.isLoading;
export const selectError = (state: RootState) => state.footage.error;
export const selectFootage = (state: RootState) => state.footage.footage;
export const selectTotalDocuments = (state: RootState) =>
  state.footage.totalDocuments;
export const selectNextQuery = (state: RootState) => state.footage.nextQuery;
export const selectPrevQuery = (state: RootState) => state.footage.prevQuery;
